import { object } from "yup";

export function normalizeStringInObject(_obj) {
    try {
        Object.keys(object).forEach(key => typeof _obj[key] == "object" ? _obj[key] = normalizeStringInObject(_obj[key]) : _obj[key] = typeof _obj[key] == "string" ? _obj[key].normalize('NFC') : _obj[key]);
        return _obj
    } catch (error) {
        return "Lỗi: " + error;
    }
}
